<div class="header">
    Select Truck Type
</div>
<div class="body">
    <div class="options">
        <div
            *ngFor="let option of truckTypes"
            class="option"
            [ngClass]="{ selected: selectedType === option.value }"
            (click)="select(option.value)">
            {{ option.label }}
        </div>
    </div>
</div>
<div class="footer">
    <div class="button cancel" (click)="cancelHandler()">Cancel</div>
    <div class="button ok" (click)="okayHandler()">OK</div>
</div>
